import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_CREATE_CASE } from 'constants/urls';
import { CasePayload } from './types';

/**
 * Creates a new case.
 * @param caseData - The case fields to create
 * @returns The API response data
 * @throws Re-throws any Axios error after logging
 */
const createCase = async (caseData: CasePayload) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_CREATE_CASE,
      data: { payload: caseData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[createCase] Failed:', error);
    throw error;
  }
};

export default createCase;
